import React from 'react';
import PropTypes from 'prop-types';
import { includes } from 'lodash';
import { Form } from 'semantic-ui-react';

import { SFEntityID } from 'utils/types';

import classNames from 'classnames';

import checkboxFilterPanelCss from './CheckboxFilterPanel.scss';

const IntakeCheckbox = ({value, label, checked, onChange}) => (
  <div className="field">
    <div className={"ui checkbox " + checkboxFilterPanelCss.blockCheckbox}>
      <label className={classNames(checkboxFilterPanelCss.intakeCheckboxLabel, {checked})}>
        <input type="checkbox"
               className="ui checkbox"
               value={value}
               checked={checked}
               onChange={onChange}
        />
        {label}
      </label>
    </div>
  </div>
);

IntakeCheckbox.propTypes = {
  value: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,

  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default class CheckboxFilterPanel extends React.Component {
  static defaultProps = {
    value: []
  };

  handleOptionChecked = e => {
    this.setOptionChecked(e.target.value, e.target.checked);
  };

  isOptionChecked(optionValue) {
    return includes(this.props.value, optionValue);
  }

  setOptionChecked(optionValue, checked) {
    if (checked === this.isOptionChecked(optionValue)) {
      return;
    }

    if (!checked) {
      this.clearOption(optionValue);
      return;
    }

    this.addSelection(this.props.value.concat(optionValue));
  }

  clearOption(removedValue) {
    const remainingSelectedValues = this.props.value.filter(value => value !== removedValue);

    if (remainingSelectedValues.length > 0) {
      this.addSelection(remainingSelectedValues);
      return;
    }

    this.props.removeSelection(this.props.question.id);
  }

  addSelection(values) {
    this.props.addSelection({
      questionId: this.props.question.id,
      type: this.props.question.type,
      value: values
    });
  }

  render() {
    return (
      <Form>
        {
          this.props.question.options.map(
            (option) =>
              <IntakeCheckbox
                key={option.id}
                value={option.display}
                label={option.display.toString()}
                checked={includes(this.props.value, option.display)}
                onChange={this.handleOptionChecked} />
          )
        }
      </Form>
    );
  }
}

CheckboxFilterPanel.propTypes = {
	addSelection: PropTypes.func,
  removeSelection: PropTypes.func,
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      id: SFEntityID.isRequired,
      display: PropTypes.oneOfType([PropTypes.number, PropTypes.string.isRequired])
    })).isRequired
  }),
  value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]))
};
